import { EventName } from 'plp/types/eventsObserver'
import { eventsObserver } from 'plp/utils/eventsObserver'
import { useEffect, useState } from 'react'
import { debounce } from 'utils/debounce'

// TODO: Change NUMBER_FIFTY by seo.shop.keytrends_she.text visible in the screen
const NUMBER_FIFTY = 50
const SCROLL_DEBOUNCE_DELAY = 1000

export function useScrollToBottom() {
	const [isBottomReached, setIsBottomReached] = useState<boolean>(false)

	useEffect(() => {
		function handleScroll() {
			if (!isBottomReached) {
				const totalHeight = document.documentElement.scrollHeight
				const scrollPosition = window.scrollY + window.innerHeight

				if (scrollPosition >= totalHeight - NUMBER_FIFTY) {
					eventsObserver.dispatch(EventName.PLP_END)
					setIsBottomReached(true)
				}
			}
		}
		const debouncedScrollToBottomEvent = debounce(
			handleScroll,
			SCROLL_DEBOUNCE_DELAY
		)

		window.addEventListener('scroll', debouncedScrollToBottomEvent)

		return () => {
			eventsObserver.unsubscribe(debouncedScrollToBottomEvent)
			window.removeEventListener('scroll', debouncedScrollToBottomEvent)
		}
	}, [isBottomReached])

	return isBottomReached
}
